import { reduceObject } from './reduceObject'
import { dateToString } from './dateToString'
import { validateInteger } from './validateInteger'

export const normalizeVictimAge = victim => {
  if (victim.age) {
    return validateInteger(parseInt(victim.age))
  } else {
    let dob = new Date(
      victim.dob.yearValue,
      victim.dob.monthValue,
      victim.dob.dayValue
    )
    var diff_ms = Date.now() - dob.getTime()
    var age_dt = new Date(diff_ms)
    return Math.abs(age_dt.getUTCFullYear() - 1970)
  }
}

export const normalizeIHSVictim = (data, id) => {
  const hasVictim = data[`victim_first_name_${id}`]
  let victim = null

  if (hasVictim && hasVictim.length > 0) {
    victim = reduceObject(
      [
        'address',
        'age',
        'dob',
        'first_name',
        'middle_name',
        'last_name',
        'suffix',
        'sex',
        'uuid'
      ],
      data,
      `victim_{}_${id}`
    )

    const clone = { ...victim }

    victim.age = normalizeVictimAge(clone)
    victim.dob = clone.dob && dateToString(clone.dob)
    victim.address = clone.address && clone.address.line1Value
    victim.address2 = clone.address && clone.address.line2Value
    victim.city = clone.address && clone.address.cityValue
    victim.state = clone.address && clone.address.stateValue
    victim.zip = clone.address && clone.address.zipValue
    victim.country = clone.address && clone.address.countryValue
  }
  return victim
}

export const normalizeIHSVictimData = (data, maxIndex = 0, index = 0) => {
  let victims = []

  for (let id = index; id <= maxIndex; id++) {
    victims.push(normalizeIHSVictim(data, id))
  }

  return victims.filter(vic => vic != undefined)
}
